<template>
  <div>
    <h1 class="page-title">User - <span class="fw-semi-bold">Profile</span></h1>
    <b-row>
      <b-col lg="6" md="12">
        <Widget>
          <legend>Informasi User</legend>
          <b-form-group horizontal label="NPWP" label-for="npwp-field" label-class="text-md-left" :label-cols="3"
            breakpoint="md">
            <b-form-input v-model="form.npwp" type="text" id="npwp-field" placeholder=""
              v-mask="'##.###.###.#-###.####'" />
            <small>*NPWP Instansi/ Perusahaan/ Perorangan</small>
          </b-form-group>
          <!-- <b-form-group
          class=""
            horizontal
            label="NIP"
            label-for="nip-field"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
          >
            <b-form-input
              v-model="form.nip"
              type="text"
              id="nip-field"
              placeholder=""
            />
          </b-form-group> -->

          <!-- <b-form-group
            horizontal
            label="Jabatan"
            label-for="jabatan-field"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
          >
            <b-form-input
              v-model="form.jabatan"
              type="text"
              id="jabatan-field"
              placeholder=""
            />
          </b-form-group> -->

          <b-form-group horizontal label="Nama" label-for="nama-field" label-class="text-md-left" :label-cols="3"
            breakpoint="md">
            <b-form-input v-model="form.nama" type="text" id="nama-field" placeholder="" />
          </b-form-group>

          <b-form-group horizontal label="Nomor Handphone" label-for="hp-field" label-class="text-md-left"
            :label-cols="3" breakpoint="md">
            <b-form-input v-model="form.no_hp" type="text" id="hp-field" placeholder="" />
          </b-form-group>

          <b-form-group horizontal label="Alamat" label-for="alamat-field" label-class="text-md-left" :label-cols="3"
            breakpoint="md">
            <b-form-textarea v-model="form.alamat" id="alamat-field" placeholder="" />
          </b-form-group>

          <b-button class="mt-5" style="float: right" variant="primary" @click="simpanInformasiUser">Simpan</b-button>
        </Widget>
      </b-col>
      <b-col lg="6" md="12">
        <Widget>
          <legend>Edit Akun</legend>
          <b-form-group horizontal label="Email" label-for="email-field" label-class="text-md-left" :label-cols="3"
            breakpoint="md">
            <b-form-input disabled v-model="form.email" type="text" id="email-field" placeholder="" />
          </b-form-group>
          <b-form-group horizontal label="Password Lama" label-for="passwordlama-field" label-class="text-md-left"
            :label-cols="3" breakpoint="md">
            <b-form-input v-model="dataPassword.password_lama" type="text" id="passwordlama-field" placeholder="" />
          </b-form-group>
          <b-form-group horizontal label="Password Baru" label-for="passwordbaru-field" label-class="text-md-left"
            :label-cols="3" breakpoint="md">
            <b-form-input v-model="dataPassword.password_baru" type="text" id="passwordbaru-field" placeholder="" />
          </b-form-group>

          <b-button class="mt-5" style="float: right" variant="primary" @click="simpanPassword()">Simpan</b-button>
        </Widget>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Widget from "@/components/Widget/Widget";
import axios from "axios";
import Swal from "sweetalert2";
import bcrypt from "bcryptjs";

export default {
  name: "Profile",
  components: { Widget },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      form: {},
      dataPassword: {
        password_lama: null,
        password_baru: null,
      },
    };
  },
  mounted() {
    this.loaddata();
  },
  methods: {
    loaddata() {
      axios
        .get(this.baseapi + "api/user/" + this.user.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.form = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    simpanInformasiUser() {
      const formData = new FormData();
      formData.append("nama", this.form.nama);
      formData.append("no_hp", this.form.no_hp);
      formData.append("alamat", this.form.alamat);
      formData.append("jabatan", this.form.jabatan);
      formData.append("nip", this.form.nip);
      formData.append("npwp", this.form.npwp);
      axios
        .post(this.baseapi + "api/user/" + this.user.id, formData, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          Swal.fire("Berhasil", "" + response.data.message + "", "success");
          this.loaddata();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async simpanPassword() {
      const { password_lama, password_baru } = this.dataPassword

      // Validasi input tidak boleh kosong atau hanya spasi
      if (!password_lama?.trim() || !password_baru?.trim()) {
        return Swal.fire("Required", "Mohon isi semua form", "error")
      }

      // Tampilkan loading indikator
      if (this.$loading) this.$loading(true)

      try {
        const body = {
          // email: this.form.email,
          old_password: password_lama,
          password: password_baru,
        }

        const response = await axios.post(
          `${this.baseapi}api/user/${this.form.id}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${this.user?.accessToken || ''}`,
            },
          }
        )

        Swal.fire("Berhasil", response.data?.message || "Password berhasil diubah", "success")

        // Reset form & reload data
        this.dataPassword.password_lama = null
        this.dataPassword.password_baru = null

        if (typeof this.loaddata === 'function') {
          this.loaddata()
        }
      } catch (error) {
        const errorMsg =
          error.response?.data?.message ||
          error.message ||
          "Gagal memperbarui password"

        Swal.fire("Gagal", errorMsg, "error")
      } finally {
        if (this.$loading) this.$loading(false)
      }
    }
  },
};
</script>

<style src="./Profile.scss" lang="scss" scoped />
